import React from 'react'


import { ResizeContext } from 'contexts/Resize'
import { Text } from 'shared/Typography'

import Person from './components/Person'
import {
  Wrapper,
  Container,
  Alert,
  HeartImage,
  Content,
  ImageBlock,
  Image,
  TextBlock,
  Title,
  Description,
} from './styles'
import heart from './assets/heart.png'
import bg from './assets/bg.png'
import bg_mob from './assets/bg_mob.png'
import john from './assets/john.png'
import emma from './assets/emma.png'
import PropTypes from 'prop-types'

export const BDiet = ({ texts }) => {
  const { mobile, tablet } = React.useContext(ResizeContext)

  const { alert_text, title, description } = texts

  return (
    <Wrapper>
      <Container>
        <Alert>
          <HeartImage src={heart} alt='heart_icon' />
          <Text
            className='h-color-V50'
            weight={'medium'}
            size={['18/28', '14/20', '14/20']}
            dangerouslySetInnerHTML={{ __html: alert_text }}
          />
        </Alert>

        <Content>
          <ImageBlock>
            <Image
              src={mobile || tablet ? bg_mob : bg}
              alt={'peach'}
            />

            <Person
              image={john}
              title={'John, 22'}
              text={'superfood'}
              color={'var(--color-V50)'}
            />

            <Person
              image={emma}
              title={'Emma, 38'}
              text={'avoid'}
              color={'var(--color-R100)'}
            />
          </ImageBlock>

          <TextBlock>
            <Title
              weight={'medium'}
              size={['50/60', '50/60', '35/40']}
              dangerouslySetInnerHTML={{ __html: title }}
            />

            <Description
              size={['22/30', '22/30', '16/25']}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </TextBlock>
        </Content>
      </Container>
    </Wrapper>
  )
}

BDiet.propTypes = {
  texts: PropTypes.object.isRequired,
}
